import React from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import topback from "../images/beetitle.png";
import PrincipalIMG from "../images/Dr. Sumiksha Gupta.jpeg";
import GURDEVSINGH from "../images/teacher/physics.jpg";
import DALIP from "../images/teacher/engli.jpg";
import GAURAV from "../images/teacher/mathteacher.jpg";
import REENA from "../images/teacher/hinditeacher.jpg";
import RECHA from "../images/teacher/chemest.jpg";
import GURMELSINGH from "../images/teacher/ecnomics.jpg";
import GURJEETKAUR from "../images/teacher/commerceone.jpg";
import BUTTA from "../images/teacher/Mr.BUTTARAM.webp";
import Uma from "../images/teacher/Uma.webp";
import RAMESH from "../images/teacher/commercetwo.jpg";
import JYOTISHARMA from "../images/teacher/historyteacher.jpg";
import VACANT from "../images/teacher/vacant.jpg";
import ANITA from "../images/teacher/anita.jpeg";
import Ritu from "../images/ritu.jpeg";
import Shivendra from "../images/Shivendra.jpeg"

function Faculty() {

  const faculty = [
    {
      name: "Dr. Sumiksha Gupta",
      designation: "Principal",
      mobile: "7018477830",
      image: PrincipalIMG,
    },
    {
      name: "DR. GAURAV SHARMA",
      designation: "Assistant Professor Mathematics",
      mobile: "9736204600",
      image: GAURAV,
    },
    {
      name: "MS RICHA SHARMA",
      designation: "Assistant Professor Chemistry",
      mobile: "9805889230",
      image: RECHA,
    },
    {
      name: "MR. GURMAIL SINGH",
      designation: "Assistant Professor Economics",
      mobile: "9882063493",
      image: GURMELSINGH,
    },
    {
      name: "MS GURJEET KAUR",
      designation: "Assistant Professor Commerce",
      mobile: "9459229580",
      image: GURJEETKAUR,
    },
    {
      name: "MR. BUTTA RAM",
      designation: "Assistant Professor Political Science",
      mobile: "9805058418",
      image: BUTTA,
    },
    {
      name: "MR. RAMESH KUMAR",
      designation: "Assistant Professor Commerce",
      mobile: "9459944562",
      image: RAMESH,
    },
    {
      name: "Mrs. Ritu Jaswal",
      designation: "Assistant Professor English",
      mobile: "",
      image: Ritu,
    },
    {
      name: "Shivendra Srivastava ",
      designation: "Assistant Professor History",
      mobile: "8924898825",
      image: Shivendra,
    },
    {
      name: "VACANT",
      designation: "Associate Professor Physics",
      mobile: "",
      image: VACANT,
    },
  ];

  return (
    <>
      <Header />
      <section className="content-section title-top" style={{ backgroundImage: `url(${topback})` }}>
        <div className="pattern-overlay">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 title-heading">
                <h2>FACULTY</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="our-webcoderskull padding-lg">
        <div className="container">

          <ul className="row padding-end" style={{ paddingLeft: 0 }}>
            {faculty.map((teacher, index) => (
              <li className="col-12 col-md-6 col-lg-3" key={index}>
                <div className="cnt-block equal-hight" style={{ height: "349px" }}>
                  <figure>
                    <img
                      src={teacher.image}
                      className="img-responsive"
                      alt={teacher.name}
                    />
                  </figure>

                  <h3>{teacher.name}</h3>

                  <p>{teacher.designation}</p>

                  <p>
                    Mobile No:{" "}
                    {teacher.mobile ? `(${teacher.mobile})` : "N/A"}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Faculty;